import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { ALIGNS } from "../consts";

var getAlign = function getAlign(align) {
  var _tokens;

  var tokens = (_tokens = {}, _defineProperty(_tokens, ALIGNS.START, "flex-start"), _defineProperty(_tokens, ALIGNS.END, "flex-end"), _defineProperty(_tokens, ALIGNS.CENTER, "center"), _defineProperty(_tokens, ALIGNS.STRETCH, "stretch"), _tokens);
  return align && tokens[align];
};

export default getAlign;